export enum AppRoutes {
    MAIN = 'main',
    AUTH = 'auth',
    ONBOARD_MOBILE = 'onboard-mobile',
    LOGIN = 'login',
    PROPERTIES = 'properties',

    PROPERTIES_ITEM = 'properties-item',
    PROPERTIES_INFO = 'properties-info',
    PROPERTIES_LEGACY_CATALOG_REDIRECT = 'properties-legacy-catalog-redirect',

    CATALOG_ROOT = 'catalog-root',
    CATALOG = 'catalog',
    CATALOG_PAGE = 'catalog-page',
    CATALOG_ITEMS = 'catalog-items',
    CATALOG_ITEM = 'catalog-item',

    CATALOG_GLOBAL = 'catalog-global',
    CATALOG_GLOBAL_ITEMS = 'catalog-global-items',
    CATALOG_GLOBAL_ITEM = 'catalog-global-item',

    CATALOG_MANAGEMENT = 'catalog-management',
    CATALOG_INVENTORY = 'catalog-inventory',
    CATALOG_INVENTORY_ITEM = 'catalog-inventory-item',
    CATALOG_INVENTORY_CATEGORIES = 'catalog-inventory-categories',
    CATALOG_INVENTORY_CATEGORIES_ITEMS = 'catalog-inventory-categories-items',

    CATALOG_LIST = 'catalog-list',
    CATALOG_LIST_ITEM = 'catalog-list-item',
    CATALOG_LIST_ADD_ITEMS = 'catalog-list-add-items',
    CATALOG_LIST_ADD_ITEMS_CATEGORIES = 'catalog-list-add-items-categories',
    CATALOG_LIST_ADD_ITEMS_CATEGORIES_DETAILED = 'catalog-list-add-items-categories-detailed',
    CATALOG_LIST_ADD_ITEMS_INVENTORY = 'catalog-list-add-items-inventory',
    CATALOG_LIST_ADD_ITEMS_INVENTORY_DETAILED = 'catalog-list-add-items-inventory-detailed',
    CATALOG_LIST_ADD_ITEMS_MARKETPLACE = 'catalog-list-add-items-marketplace',
    CATALOG_LIST_ADD_ITEMS_MARKETPLACE_CATEGORY = 'catalog-list-add-items-marketplace-category',
    CATALOG_LIST_ADD_ITEMS_MARKETPLACE_DETAILED = 'catalog-list-add-items-marketplace-detailed',

    INVENTORY_ADD = 'inventory-add',

    ORDERS = 'orders',
    ORDERS_TABLE = 'orders-table',
    ORDERS_TABLE_STATUS = 'orders-table-status',
    ORDERS_ADD_ITEMS = 'orders-add-items',
    ORDERS_ADD_ITEMS_CATEGORIES = 'orders-add-items-categories',
    ORDERS_ADD_ITEMS_INVENTORY = 'orders-add-items-inventory',
    ORDERS_ADD_ITEMS_CATEGORIES_DETAILED = 'orders-add-items-categories-detailed',
    ORDERS_ADD_ITEMS_LISTS = 'orders-add-items-lists',
    ORDERS_ADD_ITEMS_LIST = 'orders-add-items-list',
    ORDERS_ADD_ITEMS_MARKETPLACE = 'orders-add-items-marketplace',
    ORDERS_ADD_ITEMS_MARKETPLACE_DETAILED = 'orders-add-items-marketplace-detailed',
    ORDERS_VIEW = 'orders-view',
    ORDERS_VIEW_ITEM_DETAILED = 'orders-view-item-detailed',

    REPORTS = 'reports',
    REPORTS_BY_CATEGORY = 'reports-by-category',
    REPORTS_SAVINGS_SUMMARY = 'reports-savings-summary',
    REPORTS_SAVINGS_PRODUCT_DRILLIN = 'reports-savings-product-drillin',
    REPORTS_SAVINGS_PROPERTY_DRILLIN = 'reports-savings-property-drillin',
    REPORTS_SAVINGS_CATEGORY_DRILLIN = 'reports-savings-category-drillin',
    REPORTS_SPEND_SUMMARY = 'reports-spend-summary',
    REPORTS_SPEND_PRODUCT_DRILLIN = 'reports-spend-product-drillin',
    REPORTS_SPEND_PROPERTY_DRILLIN = 'reports-spend-property-drillin',
    REPORTS_SPEND_CATEGORY_DRILLIN = 'reports-spend-category-drillin',
    REPORTS_SPEND_SUPPLIER_DRILLIN = 'reports-spend-supplier-drillin',
    SETTINGS = 'settings',
    SETTINGS_ORDERS = 'settings-orders',
    SETTINGS_ORDERS_SOURCING = 'settings-orders-sourcing',
    SETTINGS_ORDERS_DELIVERY = 'settings-orders-delivery',
    SETTINGS_ORDERS_SAVINGS = 'settings-orders-savings',

    VENDORS = 'vendors',
    VENDORS_SUPPLIER_PAGE = 'vendors-supplier-page',
    ADD_VENDORS_PAGE = 'add-vendors-page',
    PROFILE = 'profile',
    PRIVACY_POLICY = 'privacy-policy',
    TERMS_OF_SERVICE = 'terms-of-service',
    PRIVACY_POLICY_EMBEDED = 'privacy-policy-embeded',
    TERMS_OF_SERVICE_EMBEDED = 'terms-of-service-embeded',
    // error pages
    FORBIDDEN = 'forbidden',
    ACCESS_DENIED = 'access-denied',
    NOT_FOUND_PAGE = 'not-found-page',
    // last
    NOT_FOUND = 'not-found',
}

export const getRouteMain = () => '/';
export const getRouteAuth = () => '/auth';
export const getOnboardMobile = () => '/onboard-mobile';
export const getRouteLogin = () => '/login';
export const getRouteProperties = () => `/properties`;
export const getRouteCatalogRoot = () => '/catalog';

export const getRoutePropertiesItem = (propertyId: string) =>
    `/properties/${propertyId}`;

export const getRouteCatalog = (propertyId: string) => `/catalog/${propertyId}`;

export const getRouteGlobalCatalog = (propertyId: string) =>
    `/catalog/${propertyId}/global`;

export const getRouteCatalogSelected = (
    propertyId: string,
    categoryId: string,
) => `/catalog/${propertyId}/${categoryId}`;

export const getRouteGlobalCatalogSelected = (
    propertyId: string,
    categoryId: string,
) => `/catalog/${propertyId}/global/${categoryId}`;

export const getRouteCatalogItem = (
    propertyId: string,
    categoryId: string,
    itemId: string,
) => `/catalog/${propertyId}/${categoryId}/item/${itemId}`;

export const getRouteGlobalCatalogItem = (
    propertyId: string,
    categoryId: string,
    itemId: string,
) => `/catalog/${propertyId}/global/${categoryId}/item/${itemId}`;

export const getRouteCatalogInventory = (propertyId: string) =>
    `/catalog/${propertyId}/inventory`;

export const getRouteCatalogInventoryItem = (
    propertyId: string,
    itemId: string,
) => `/catalog/${propertyId}/inventory/${itemId}`;

export const getRouteOrderCatalogCategoriesItem = (itemId: string) =>
    `/orders/add-items/categories/${itemId}`;

export const getRouteCatalogInventoryCategories = (propertyId: string) =>
    `/catalog/${propertyId}/inventory/categories`;

export const getRouteCatalogInventoryCategoriesSelected = (
    propertyId: string,
    categoryId: string,
) => `/catalog/${propertyId}/inventory/categories/${categoryId}`;

export const getRoutePropertiesCatalogInventoryCategoriesItem = (
    propertyId: string,
    categoryId: string,
    itemId: string,
) =>
    `/properties/${propertyId}/catalog/inventory/categories/${categoryId}/${itemId}`;

export const getRouteInventoryAdd = (propertyId: string) =>
    `/catalog/${propertyId}/inventory/add`;

export const getRouteCatalogList = (propertyId: string, listId: string) =>
    `/catalog/${propertyId}/lists/${listId}`;

export const getRouteCatalogListItem = (
    propertyId: string,
    listId: string,
    itemId: string,
) => `/catalog/${propertyId}/lists/${listId}/item/${itemId}`;

export const getRouteCatalogListAddItems = (
    propertyId: string,
    listId: string,
) => `/catalog/${propertyId}/lists/${listId}/add-items`;

export const getRouteCatalogListAddItemsCategories = (
    propertyId: string,
    listId: string,
) => `/catalog/${propertyId}/lists/${listId}/add-items/categories`;

export const getRouteCatalogListAddItemsCategoriesItem = (
    propertyId: string,
    listId: string,
    itemId: string,
) => `/catalog/${propertyId}/lists/${listId}/add-items/categories/${itemId}`;

export const getRouteCatalogListAddItemsInventory = (
    propertyId: string,
    listId: string,
) => `/catalog/${propertyId}/lists/${listId}/add-items/inventory`;

export const getRouteCatalogListAddItemsInventoryItem = (
    propertyId: string,
    listId: string,
    itemId: string,
) => `/catalog/${propertyId}/lists/${listId}/add-items/inventory/${itemId}`;

export const getRouteCatalogListAddItemsMarketplace = (
    propertyId: string,
    listId: string,
) => `/catalog/${propertyId}/lists/${listId}/add-items/marketplace`;

export const getRouteCatalogListAddItemsMarketplaceCategory = (
    propertyId: string,
    listId: string,
    categoryId: string,
) =>
    `/catalog/${propertyId}/lists/${listId}/add-items/marketplace/${categoryId}`;

export const getRouteCatalogListAddItemsMarketplaceItem = (
    propertyId: string,
    listId: string,
    categoryId: string,
    itemId: string,
) =>
    `/catalog/${propertyId}/lists/${listId}/add-items/marketplace/${categoryId}/item/${itemId}`;

/** @deprecated Use getRouteCatalog — kept for legacy URL redirects */
export const getRoutePropertiesCatalog = (propertyId: string) =>
    `/properties/${propertyId}/catalog`;

export const getRouteOrders = () => '/orders';
export const getRouteHome = () => getRouteOrders();
export const getRouteOrdersTable = (orderId: string) =>
    `/orders/properties/${orderId}`;

export const getRouteOrdersTableByStatus = (
    orderId: string,
    orderStatus: string,
) => `/orders/properties/${orderId}/status/${orderStatus}`;

export const getRouteOrdersAddItems = () => '/orders/add-items';
export const getRouteOrdersAddItemsCategories = () =>
    '/orders/add-items/categories';
export const getRouteOrdersAddItemsInventory = () =>
    '/orders/add-items/inventory';
export const getRouteOrdersAddItemsLists = () => '/orders/add-items/lists';
export const getRouteOrdersAddItemsList = (listId: string) =>
    `/orders/add-items/lists/${listId}`;
export const getRouteOrdersAddItemsMarketplace = () =>
    '/orders/add-items/marketplace';
export const getRouteOrderMarketplaceCategory = (categoryId: string) =>
    `/orders/add-items/marketplace/${categoryId}`;
export const getRouteOrderMarketplaceItem = (
    categoryId: string,
    itemId: string,
) => `/orders/add-items/marketplace/${categoryId}/item/${itemId}`;

export const getRouteOrdersView = (id: string) => `/orders/${id}`;
export const getRouteOrdersViewItemDetailed = (
    orderId: string,
    itemId: string,
) => `/orders/${orderId}/item/${itemId}`;

export const getRouteMainReports = () => `/reports`;
export const getRouteMainVendors = (propertyId: string) =>
    `/vendors/property/${propertyId}`;
export const getRouteAddVendors = (propertyId: string) =>
    `/vendors/property/${propertyId}/add-vendors`;
export const getRouteVendorsSupplierPage = (
    supplierId: string,
    propertyId: string,
) => `/vendors/property/${propertyId}/suppliers/${supplierId}`;
export const getRouteReportsByCategory = () => `/reports/category`;
export const getRouteReportsSavingsSummary = () => `/reports/savings-summary`;
export const getRouteReportsSpendSummary = () => `/reports/spend-summary`;

const encodeRouteSegment = (value: string) =>
    value.startsWith(':') ? value : encodeURIComponent(value);

export const getRouteReportsSavingsSummaryProduct = (sku: string) =>
    `/reports/savings-summary/product/${encodeRouteSegment(sku)}`;
export const getRouteReportsSavingsSummaryProperty = (propertyId: string) =>
    `/reports/savings-summary/property/${encodeRouteSegment(propertyId)}`;
export const getRouteReportsSavingsSummaryCategory = (categoryId: string) =>
    `/reports/savings-summary/category/${encodeRouteSegment(categoryId)}`;
export const getRouteReportsSpendSummaryProduct = (sku: string) =>
    `/reports/spend-summary/product/${encodeRouteSegment(sku)}`;
export const getRouteReportsSpendSummaryProperty = (propertyId: string) =>
    `/reports/spend-summary/property/${encodeRouteSegment(propertyId)}`;
export const getRouteReportsSpendSummaryCategory = (categoryId: string) =>
    `/reports/spend-summary/category/${encodeRouteSegment(categoryId)}`;
export const getRouteReportsSpendSummarySupplier = (supplierId: string) =>
    `/reports/spend-summary/supplier/${encodeRouteSegment(supplierId)}`;

export const getRouteSettings = () => `/settings`;

export const getRouteSettingsOrdersSourcing = (
    propertyId: string,
    orderType: string,
) => `/settings/${propertyId}/orders/${orderType}`;
export const getRouteSettingsOrdersDelivery = (
    propertyId: string,
    orderType: string,
) => `/settings/${propertyId}/orders/${orderType}/delivery`;
export const getRouteSettingsOrdersSavings = (
    propertyId: string,
    orderType: string,
) => `/settings/${propertyId}/orders/${orderType}/savings`;

export const getRouteProfile = () => `/profile/details`;
export const getRoutePrivacyPolicy = () => `/privacy-policy`;
export const getRouteTermsOfService = () => `/terms-of-service`;
export const getRoutePrivacyPolicyEmbeded = () => `/profile/privacy-policy`;
export const getRouteTermsOfServiceEmbeded = () => `/profile/terms-of-service`;

//error pages
export const getRouteAccessDenied = () => '/access-denied';
export const getRouteForbidden = () => '/forbidden';
export const getRouteNotFound = () => '/not-found';
